import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { Button } from '@contrast-security-inc/design-system-buttons'

export function CancelButton({ onClick }) {
  return (
    <FormattedMessage id="action_cancel">
      {(text) => {
        return (
          <Button
            variant="secondary"
            className={css`
              margin-left: 8px;
            `}
            onClick={onClick}
          >
            {text}
          </Button>
        )
      }}
    </FormattedMessage>
  )
}
